import React, { useMemo, useState } from 'react';
import useClassificationLabelHook from '../hooks/useClassificationLabelHook'; // Use default import
import TrainingConfigModal from '../../components/TrainingConfigModal';

const TRAINING_CONFIG_STORAGE_KEY = 'lf-classification-training-config';

const defaultAdvancedOptions = {
  enableStratify: true,
  enableSplitControls: true,
  enableBatchSize: true,
  enableEarlyStopping: true,
  batchSizeOptions: [1,2,4,8, 16],
  minTrainPercent: 50,
  splitLabels: { train: 'Train', val: 'Validation', test: 'Test' },
};

const fallbackConfig = {
  modelVariant: 'yolov8n-cls.pt',
  epochs: 5,
  imgsz: 224,
  stratify: true,
  trainSplit: 70,
  valSplit: 20,
  testSplit: 10,
  batchSize: 16,
  enableEarlyStopping: true,
  patience: 50,
};

const loadStoredTrainingConfig = () => {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return fallbackConfig;
  }
  try {
    const raw = window.sessionStorage.getItem(TRAINING_CONFIG_STORAGE_KEY);
    if (!raw) return fallbackConfig;
    const parsed = JSON.parse(raw);
    return {
      ...fallbackConfig,
      ...parsed,
    };
  } catch (error) {
    console.warn('Unable to load stored classification training config', error);
    return fallbackConfig;
  }
};

const ClassificationFilter = () => {
  const {
    handlers
  } = useClassificationLabelHook();
  const [isTrainingModalOpen, setTrainingModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [defaultConfig, setDefaultConfig] = useState(loadStoredTrainingConfig);

  const modelOptions = [
    'yolov8n-cls.pt',
    'yolo11n-cls.pt',
  ];

  const persistConfig = (config) => {
    setDefaultConfig(config);
    if (typeof window === 'undefined' || !window.sessionStorage) return;
    try {
      window.sessionStorage.setItem(TRAINING_CONFIG_STORAGE_KEY, JSON.stringify(config));
    } catch (error) {
      console.warn('Unable to persist classification training config', error);
    }
  };

  const handleTrainingSubmit = async (config) => {
    try {
      setIsSubmitting(true);
      const result = await handlers.handleStartClassificationTraining(config);
      if (result !== false) {
        persistConfig(config);
        setTrainingModalOpen(false);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="page-header-title">
        <h5 className="m-b-10">Classification labeling</h5>
        <div>
          <button className='btn btn-secondary btn-sm' onClick={() => handlers.handleSaveClassificationData()}>Temp Save</button>
          <button className='btn btn-primary btn-sm' onClick={handlers.handleDownloadClassificationData}>Export</button>
          <button className='btn btn-primary btn-sm' onClick={() => setTrainingModalOpen(true)}>Training</button>
        </div>
      </div>
      <TrainingConfigModal
        title="Classification Training Configuration"
        isOpen={isTrainingModalOpen}
        defaults={defaultConfig}
        modelOptions={modelOptions}
        onSubmit={handleTrainingSubmit}
        onClose={() => setTrainingModalOpen(false)}
        submitting={isSubmitting}
        advancedOptions={defaultAdvancedOptions}
      />
    </>
  );
};

export default ClassificationFilter;
